var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H104C112.837 0 120 7.16344 120 16V100C120 133.137 93.1371 160 60 160C26.8629 160 0 133.137 0 100V16Z",
    fill: "#B5B5C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 11.268 10.268 5 18 5H102C109.732 5 116 11.268 116 19V100C116 130.928 90.928 156 60 156C29.0721 156 4 130.928 4 100V19Z",
    fill: "url(#paint0_linear_12_2121)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "url(#paint1_linear_12_2121)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 73L60 64L71 73V101L60 110L49 101V73Z",
    fill: "#F94B4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53V64L71 73L83 67.5L60 53Z",
    fill: "#DC2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53V64L49 73L37 67.5L60 53Z",
    fill: "#FFA6A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 121V110L71 101L83 106.5L60 121Z",
    fill: "#9E0000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60 121V110L49 101L37 106.5L60 121Z",
    fill: "#BF1111"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83 67.5L71 73V101L83 106.5V67.5Z",
    fill: "#BF1111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67.5L49 73V101L37 106.5V67.5Z",
    fill: "#DC2E2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2121",
    x1: 6.24,
    y1: 8.99815,
    x2: 35.479,
    y2: 114.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#A6A5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898838,
    stopColor: "#D9D9DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2121",
    x1: 60,
    y1: 29,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A152D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#390913"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyIcon);
export default __webpack_public_path__ + "static/media/rubyIcon.3dfeb8d8f6071094f3f86dfacced14ec.svg";
export { ForwardRef as ReactComponent };